import {useSelector} from "react-redux";
import Button from '@mui/material/Button';
import {Space, Divider} from "antd";
import ResponseMessage from "./ResponseMessage";
import Placeholder from "../../Components/Placeholder";

const ResponseCollection = ({onAddTouchpoint}) => {
    const responseObjects = useSelector(state => state.gptApi.responses);
    const responses = responseObjects && Object.entries(responseObjects).map(([id, value]) => ({id, ...value}));

    if (!responses) return <Placeholder text={'No Responses Yet'}/>;

    return (
        <Space direction={'vertical'} style={{width: '100%'}}>
            {responses && responses.map((response, index) => (
                <>
                    <ResponseMessage
                        key={index}
                        response={response}
                        extra={
                            onAddTouchpoint && <Space><Button onClick={()=>onAddTouchpoint(response.data)}>Move to Editor</Button></Space>
                        }
                    />
                    <Divider/>
                </>
            ))}
        </Space>
    );
}

export default ResponseCollection;